.base {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	flex: 1;
	gap: 8px;
	padding: 20px;
}

.orb {
	width: 48px;
	height: 48px;
}

.title {
	font-size: var(--parrot-chat-font-size-lg);
	font-weight: var(--parrot-chat-font-weight-bold);
	margin-top: 8px;
	color: var(--parrot-chat-text);
}

.subtitle {
	font-size: var(--parrot-chat-font-size-sm);
	color: var(--parrot-chat-text-muted);
	max-width: 280px;
	line-height: 1.5;
}

.suggestArea {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 16px;
	width: 100%;
	max-width: 360px;
}

.pills {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 8px;
}

/* Floating panel: overlays the pill row (replacing it) without taking
   layout space, so the icon/title/subtitle above never reflow. */
.panel {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	margin: 0 auto;
	width: 100%;
	display: flex;
	flex-direction: column;
	max-height: 260px;
	background: var(--parrot-chat-surface);
	border: 1px solid var(--parrot-chat-border-strong);
	border-radius: var(--parrot-chat-radius-lg);
	box-shadow: 0 12px 32px -8px rgba(0, 0, 0, 0.6);
	overflow: hidden;
	z-index: 2;
	text-align: left;
	animation: panelIn 0.16s ease-out both;
}

.panelClosing {
	animation: panelOut 0.16s ease-in both;
}

.panelHeader {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	padding: 8px 8px 8px 14px;
	border-bottom: 1px solid var(--parrot-chat-border);
	flex-shrink: 0;
}

.panelTitle {
	font-size: var(--parrot-chat-font-size-sm);
	font-weight: var(--parrot-chat-font-weight-medium);
	color: var(--parrot-chat-text);
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.panelClose {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	flex-shrink: 0;
	padding: 0;
	background: transparent;
	border: none;
	border-radius: var(--parrot-chat-radius);
	color: var(--parrot-chat-text-muted);
	font-size: 18px;
	line-height: 1;
	cursor: pointer;
	transition: color 0.12s, background 0.12s;
}

.panelClose:hover {
	color: var(--parrot-chat-text);
	background: rgba(255, 255, 255, 0.06);
}

.panelBody {
	position: relative;
	display: flex;
	flex: 1;
	min-height: 0;
}

.panelQuestions {
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 10px;
	overflow-y: auto;
}

/* Scroll shadows overlaid on top of the questions; toggled by scroll position. */
.shadowTop,
.shadowBottom {
	position: absolute;
	left: 0;
	right: 0;
	height: 28px;
	pointer-events: none;
	opacity: 0;
	transition: opacity 0.15s;
	z-index: 1;
}

.shadowTop {
	top: 0;
	background: linear-gradient(to bottom, var(--parrot-chat-scroll-shadow), transparent);
}

.shadowBottom {
	bottom: 0;
	background: linear-gradient(to top, var(--parrot-chat-scroll-shadow), transparent);
}

.shadowVisible {
	opacity: 1;
}

@keyframes panelIn {
	from { opacity: 0; transform: translateY(-6px) scale(0.98); }
	to { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes panelOut {
	from { opacity: 1; transform: translateY(0) scale(1); }
	to { opacity: 0; transform: translateY(-6px) scale(0.98); }
}

.pill {
	background: rgba(255, 255, 255, 0.04);
	border: 1px solid var(--parrot-chat-border);
	border-radius: 999px;
	padding: 6px 14px;
	font-size: var(--parrot-chat-font-size-sm);
	color: var(--parrot-chat-text-secondary);
	cursor: pointer;
	white-space: nowrap;
	font-family: inherit;
	transition: color 0.15s, background 0.15s, border-color 0.15s;
}

.pill:hover {
	color: var(--parrot-chat-text);
	border-color: var(--parrot-chat-accent);
}

.suggestion {
	background: rgba(255, 255, 255, 0.04);
	border: 1px solid var(--parrot-chat-border);
	border-radius: var(--parrot-chat-radius-lg);
	padding: 10px 14px;
	font-size: var(--parrot-chat-font-size-sm);
	color: var(--parrot-chat-text-secondary);
	cursor: pointer;
	transition: color 0.15s, background 0.15s, border-color 0.15s, box-shadow 0.15s;
	text-align: left;
	font-family: inherit;
}

.suggestion:hover {
	color: var(--parrot-chat-text);
	background: rgba(255, 255, 255, 0.06);
	border-color: var(--parrot-chat-accent);
	box-shadow: 0 0 12px rgba(137, 130, 231, 0.3);
}
